<template>
    <div >
      <button class="mybutton" @click="createp" >{{msg}}</button>
      
    </div>
  </template>
  
  <script>
  export default {
    name: 'MyButton',
    props: {
      msg: String
    },
    methods:{
        createp(){
            alert("About to Create the main site")
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    .mybutton{
        border-radius: 3px;
        background-color: rgba(116, 116, 155,0.2);
        cursor: pointer;
        border: 1px;
        color: lightslategray;

    }
  </style>
  